import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface MobilePhoneBrand {
    readonly MobilePhone: unique symbol;
}
export const MobilePhone = brand(
    NonEmptyString,
    // FIXME: implement actual mobile phone validation
    (n): n is Branded<NonEmptyString, MobilePhoneBrand> => true,
    'MobilePhone'
);
export type MobilePhone = TypeOf<typeof MobilePhone>;
